export default __webpack_public_path__ + "static/crunchbase-070e8f39faea192ffabd6e21aadd5fb2.svg";